import generator from 'redux/hor/module';
import fetchWithView from 'redux/utils/fetchWithView';

const {
  reducer,
  fetch,
} = generator({
  name: 'Portions',
  tableId: 62,
});

export const fetchList = fetchWithView(fetch, 'ts5c62cs9r355', {
  useLS: true,
});

export {
  getItem,
} from 'redux/hor/module/selectors';

export {
  getPortions,
} from './selectors';

export default reducer;
